/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  PODCAST_ABOUT_RENDERED: null,
  PODCAST_CARD_RENDERED: null,
  PODCAST_CARDGROUP_RENDERED: null,
  PODCAST_DESCRIPTION_RENDERED: null,
  PODCAST_EPISODE_DESCRIPTION_RENDERED: null,
  PODCAST_EPISODE_TITLE_RENDERED: null,
  PODCAST_IMAGE_RENDERED: null,
  PODCAST_PLAYBUTTON_RENDERED: null,
  PODCAST_PROGRESS_RENDERED: null,
  PODCAST_SECTION_TITLE_RENDERED: null,
  PODCAST_TITLE_RENDERED: null,
  PODCAST_TOGGLE_ABOUT_RENDERED: null,
  PODCAST_TOGGLE_DESCRIPTION_RENDERED: null
});
